import { CSSProperties } from "react";

export const styles: Record<string, CSSProperties> = {
  container: {
    minWidth: 320,
    padding: 16,
  },
};
